<template>
    <v-app class="mt-6">
        <div class="Nav">
            <div class="searchInput ml-6">
                <v-sheet elevation="0">
                    <v-text-field id="search" name="Search" variant="plain" :placeholder="$t('navBar.search')"
                        persistent-placeholder density="compact" dense hide-details class="pa-0" v-model="search"
                        maxlength="30" v-on:update:model-value="onFilter(this.search)">
                        <template #append-inner>
                            <v-icon id="SearchBTN" name="SearchBTN" @Click="onFilter(this.search)"
                                style="height: 40px; width: 40px;">mdi-magnify</v-icon>
                        </template>
                    </v-text-field>
                </v-sheet>
            </div>

            <div class="rightBloc">
                <div class="notification">
                    <v-menu transition="slide-y-transition" bottom offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn v-bind="props" id="Notification" name="Notification" flat variant="flat"
                                @click="getNotifications">
                                <v-badge v-if="hasNewNotification" color="#F25C5C" dot>
                                    <v-icon size="x-large" icon="mdi-bell-outline" color="#92929D"></v-icon>
                                </v-badge>
                                <v-icon v-else size="x-large" icon="mdi-bell-outline" color="#92929D"></v-icon>
                            </v-btn>
                        </template>

                        <v-card v-if="loading" width="500">
                            <v-card-text class="d-flex justify-center align-center">
                                <v-progress-circular indeterminate></v-progress-circular>
                            </v-card-text>
                        </v-card>

                        <template v-else>
                            <v-card v-if="hasNotification" width="350">
                                <v-card-title class="text-h6 py-2">{{ $t("notification.notifications") }}</v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="scrollable-list pa-0">
                                    <v-list class="pa-0">
                                        <v-list-item v-for="(notification, index) in history" :key="index" class="pa-0">
                                            <div
                                                :class="['notification-wrapper', !notification.isRead ? 'unread' : '']">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        class="text-subtitle-2 font-weight-medium pt-3 pl-6">{{
                                                        notification.title }}</v-list-item-title>
                                                    <v-list-item-subtitle
                                                        class="text-caption text-medium-emphasis mb-1  pl-6 ">{{
                                                        notification.body }}</v-list-item-subtitle>
                                                    <v-list-item-subtitle class="text-caption pl-6"
                                                        style="color: #3bbaff; ">{{ formatDateTime(notification.created)
                                                        }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </v-card-text>
                                <v-card-actions class="pa-2">
                                    <v-btn @click="Increment" variant="text" color="primary" class="text-caption"
                                        :loading="loadingMore" :disabled="loadingMore">
                                        {{ loadingMore ? $t("notification.Loading") : $t("notification.showMore") }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                            <v-btn v-else class="btn d-flex mt-1 mx-auto" size="small" rounded="pill"
                                style="background-color: red;">
                                <span class="btn-Text" style="color: white;">{{ $t("notification.no") }}</span>
                            </v-btn>
                        </template>
                    </v-menu>
                </div>
            </div>
            <div class="avatar">
                <v-avatar class="mt-1">
                    <img :src="user.avatar" :alt="user.name" style="max-width: 100%; height: auto;" />
                </v-avatar>
            </div>
            <the-language-picker class="mt-1"></the-language-picker>
            <div class="profileName ml-2 mr-7">
                <p class="userName mb-1">{{ user.name }}</p>
                <v-menu transition="slide-y-transition" bottom>
                    <template v-slot:activator="{ props }">
                        <v-btn class="btn d-flex " size="small" rounded="pill" color="white"
                            style="background-color: #3bbaff;" append-icon="mdi-chevron-down" v-bind="props"
                            id="ViewOptions" name="ViewOptions">
                            <span class="btn-Text" style="color: white;">{{ $t("navBar.options") }}</span>
                            <template v-slot:prepend>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12.0001 9.32C13.1901 9.32 14.1601 8.35 14.1601 7.16C14.1601 5.97 13.1901 5 12.0001 5C10.8101 5 9.84009 5.97 9.84009 7.16C9.84009 8.35 10.8101 9.32 12.0001 9.32Z"
                                        stroke="#FFF" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M6.78988 18.9999C7.97988 18.9999 8.94988 18.0299 8.94988 16.8399C8.94988 15.6499 7.97988 14.6799 6.78988 14.6799C5.59988 14.6799 4.62988 15.6499 4.62988 16.8399C4.62988 18.0299 5.58988 18.9999 6.78988 18.9999Z"
                                        stroke="#FFF" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M17.21 18.9999C18.4 18.9999 19.37 18.0299 19.37 16.8399C19.37 15.6499 18.4 14.6799 17.21 14.6799C16.02 14.6799 15.05 15.6499 15.05 16.8399C15.05 18.0299 16.02 18.9999 17.21 18.9999Z"
                                        stroke="#FFF" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </template>
                        </v-btn>
                    </template>
                    <v-list rounded="4" style="width: 200px; margin-top: 3px; padding: 10px 0;">
                        <!-- <v-divider thickness="2" class="border-opacity-25" style="margin: 2px 0;"></v-divider> -->
                        <v-list-item @click="logout()">
                            <v-list-item-title>{{ $t("navBar.logout") }}</v-list-item-title>
                            <template v-slot:prepend>
                                <svg class="mx-2" width="18" height="18" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M17.4409 15.3699C17.2509 15.3699 17.0609 15.2999 16.9109 15.1499C16.6209 14.8599 16.6209 14.3799 16.9109 14.0899L18.9409 12.0599L16.9109 10.0299C16.6209 9.73994 16.6209 9.25994 16.9109 8.96994C17.2009 8.67994 17.6809 8.67994 17.9709 8.96994L20.5309 11.5299C20.8209 11.8199 20.8209 12.2999 20.5309 12.5899L17.9709 15.1499C17.8209 15.2999 17.6309 15.3699 17.4409 15.3699Z"
                                        fill="#001E50" />
                                    <path
                                        d="M19.9298 12.8101H9.75977C9.34977 12.8101 9.00977 12.4701 9.00977 12.0601C9.00977 11.6501 9.34977 11.3101 9.75977 11.3101H19.9298C20.3398 11.3101 20.6798 11.6501 20.6798 12.0601C20.6798 12.4701 20.3398 12.8101 19.9298 12.8101Z"
                                        fill="#001E50" />
                                    <path
                                        d="M11.7598 20.75C6.60977 20.75 3.00977 17.15 3.00977 12C3.00977 6.85 6.60977 3.25 11.7598 3.25C12.1698 3.25 12.5098 3.59 12.5098 4C12.5098 4.41 12.1698 4.75 11.7598 4.75C7.48977 4.75 4.50977 7.73 4.50977 12C4.50977 16.27 7.48977 19.25 11.7598 19.25C12.1698 19.25 12.5098 19.59 12.5098 20C12.5098 20.41 12.1698 20.75 11.7598 20.75Z"
                                        fill="#001E50" />
                                </svg>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </div>
    </v-app>
</template>
<script>
import { logout, getBackOfficeNotification, setNotificationAsRead } from "@/api/index";
import TheLanguagePicker from "@/genericComponent/TheLanguagePicker.vue";
import store from '@/store';
export default {
    components: { TheLanguagePicker },
    /* eslint-disable */
    data() {
        return {
            search: "",
            value: "",
            user: {
                name: localStorage.Name,
                avatar:
                    "data:image/png;base64,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",
            },
            history: [],
            PageNumber: null,
            PageSize: 5,
            searchNotif: null,
            CreationDate: null,
            loading: false,
            loadingMore: false,
        };
    },
    methods: {
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },

        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        logout() {
            logout()
            this.$store.dispatch('logout')
            this.$router.push('/')
        },
        onFilter: function () {
            this.emitter.emit('event-test', this.search);
        },
        getNotifications() {
            store.dispatch('setLtsNotificationToEmpty');
            this.loading = true
            getBackOfficeNotification(this.PageNumber, this.PageSize, this.searchNotif, this.CreationDate).then((response) => {
                this.history = response.data.items
                const Ids = this.history
                    .filter(notif => !notif.isRead)
                    .map(no => no.notificationId);
                if (Ids.length > 0) {
                    setNotificationAsRead(Ids).then(() => {
                        //this.ActiveSavedSnackBar();
                    }).catch(() => {
                        //this.ActiveWarningSnackBar();
                    })
                }
            }).finally(() => {
                this.loading = false
            })
        },
        Increment(e) {
            e.stopPropagation();
            this.loadingMore = true;
            this.PageSize += 5;
            getBackOfficeNotification(this.PageNumber, this.PageSize, this.searchNotif, this.CreationDate)
                .then((response) => {
                    this.history = response.data.items;
                })
                .finally(() => {
                    this.loadingMore = false;
                });
        },
        formatDateTime(dateTimeString) {
            if (!dateTimeString) return '';
            const date = new Date(dateTimeString);
            const formattedDate = date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
            const formattedTime = date.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
            return `${formattedDate} ${formattedTime}`;
        }
    },
    created() {
        this.emitter.on('remise-search-at-null', (event) => {
            this.search = null;
        })
    },
    computed: {
        notificationHistory() {
            return this.$store.getters.ltsNotification
        },
        hasNotification() {
            return this.history.length > 0;

        },
        hasNewNotification() {
            return this.$store.getters.ltsNotification.length > 0;
        }
    },
    watch: {
        notificationHistory: {
            handler(newVal) {
                this.history = newVal;
            },
            deep: true,
            immediate: true
        }
    }
};

</script>
<style scoped>
.searchInput {
    width: 100%;
}

.profileName {
    margin-right: 5px;
    min-width: max-content;
}

.notification {
    width: 100%;
    align-items: flex-end;
}

.Nav {
    display: flex;
}

.rightBloc {
    width: 100%;
    margin-top: 5px;
    text-align: right;
}

.notification-wrapper {
    width: 100%;
    min-height: 80px;
}

.unread {
    background-color: #7ecffb2b !important;
}

.btn {
    background-color: #3bbaff;
    margin-top: -1px;
    margin-left: -1px;
    border: transparent
}

.btn-Text {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    white-space: nowrap;
    color: #FFFFFF;
}

.userName {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    white-space: nowrap;
    opacity: 1;
    color: #1B194B;
}

.Nav select {
    padding: 14px 16px;
    margin: 20px;
}

.scrollable-list {
    max-height: 400px;
    overflow-y: auto;
}

.scrollable-list::-webkit-scrollbar {
    width: 6px;
}

.scrollable-list::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.scrollable-list::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

.scrollable-list::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.v-list-item {
    min-height: unset !important;
    padding: 0 !important;
}

.v-list-item-content {
    width: 100%;
}

.v-list-item-title {
    margin-bottom: 4px;
}

.v-list-item-subtitle {
    margin-top: 2px;
}
</style>